// extracted by mini-css-extract-plugin
module.exports = {"loader":"TermsOfService_loader__WooC0","root":"TermsOfService_root__52TBK","lastUpdated":"TermsOfService_lastUpdated__1cplt"};